const createPauseNotificationsState = (state, payload) => ({
  isPause: true,
  priority: payload.priority
});

export default createPauseNotificationsState;
